import {Box, HStack, StyleProps, Text, VStack} from '@chakra-ui/react';
import {DisplayLabels} from './DisplayLabels';
import {ListeDrapeaux} from '../components/listeDrapeaux';
import {VignetteArticleVStack} from '@/domains/mediatheque/VignetteArticleVStack';
import {EncartDLC} from '@/domains/ligneProduit/EncartDLC';
import {Navigable} from '@synako/halitrek';
import {useHalState} from '@synako/haligator';
import {DisponibiliteArticleDesc} from 'api-types/ffconnect-hal';
import ColdIcon from '@/components/svg/ColdIcon';
import {useApi} from '@/haligator-factory';

export const ArticleBlockCatalogueGrandCompte: React.FC<
  {
    code_article: string;
    dispo?: Navigable<DisponibiliteArticleDesc>;
    libelleFallback?: string;
    onClick?: () => void;
  } & StyleProps
> = ({code_article, dispo: navDispo, libelleFallback, ...props}) => {
  const articleNav = useApi().follow('get-article', {code_article});
  const article = useHalState(articleNav);

  return (
    <HStack
      alignItems='start'
      cursor={props.onClick ? 'pointer' : 'default'}
      mr='2em'
      {...props}
      position='relative'
    >
      <Box
        position='absolute'
        top='30px'
        left='0px'
      >
        {article.data?.temperature_livraison === 'negatif' && (
          <ColdIcon boxSize='25px' />
        )}
      </Box>
      <VignetteArticleVStack
        article={article.navigable}
        boxSize='60px'
      />
      <VStack
        alignItems='start'
        gap='0'
      >
        <HStack alignContent='baseline'>
          <Text
            fontSize='xs'
            fontWeight='400'
          >
            {code_article}
          </Text>
          <DisplayLabels
            SIQO_et_regimes_alimentaires={
              article.data?.tolede.SIQO_et_regimes_alimentaires
            }
          />
          <ListeDrapeaux
            listepays={article.data?.tolede.pays_d_origine ?? []}
          />
        </HStack>
        {/* Desktop */}
        <Text
          display={{base: 'none', md: 'block'}}
          fontWeight='600'
          lineHeight='16px'
          maxW='400px'
        >
          {article.data?.tolede.libelle_commercial ?? libelleFallback}
        </Text>
        <Text
          display={{base: 'none', md: 'block'}}
          lineHeight='16px'
          maxH='32px'
          maxW='400px'
        >
          {article.data?.tolede.marque?.[0]}
        </Text>
        {/* Mobile */}
        <Text
          display={{base: 'block', md: 'none'}}
          fontWeight='600'
          lineHeight='16px'
        >
          {article.data?.tolede.libelle_commercial ?? libelleFallback}&nbsp;
          {article.data?.tolede.marque?.[0]}
        </Text>
        <EncartDLC dispo={navDispo} />
      </VStack>
    </HStack>
  );
};
